module.exports = __webpack_public_path__ + "static/wordpress-white-b670cb79b19d2dd94c8bac3273902e02.png";